
import React from 'react'
import { MDXTag } from '@mdx-js/tag'


export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"swift-shop-hiatus"}}>{`Swift Shop Hiatus`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"jan-26-2020"}}>{`Jan 26, 2020`}</MDXTag>
<MDXTag name="p" components={components}>{`Haven’t been working on the project or posting during the last few weeks due to sickness, and now another project has come up that I’d like to prioritize.`}</MDXTag>
<MDXTag name="p" components={components}>{`I do hope to return to Swift Shop in the next couple of months, but we’ll have to see!`}</MDXTag>
           </MDXTag>
  }
}
export const tableOfContents = (components={}) => [
  {
    id: "jan-26-2020",
    level: 3,
    title: "Jan 26, 2020",
    children: [
        
      ]
  }
]

export const frontMatter = {}

